import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10 14.167c2.758 0 5-2.242 5-5V2.5h-2.083v6.667A2.92 2.92 0 0110 12.083a2.92 2.92 0 01-2.917-2.916V2.5H5v6.667c0 2.758 2.242 5 5 5zm-5.833 1.666V17.5h11.666v-1.667H4.167z" fill="#54585D" /></svg>);